import { useMutation, useQueryClient } from '@tanstack/react-query';
import AppointmentService from '@/services/AppointmentService';
import type { RequestAppointmentOpts } from '@/services/AppointmentService';
import { TASK_KEYS } from '@/state/data/task/keys';
import { scheduleInvalidate } from '@/state/data/_shared/wf-race';

// Async via Tier 4 appointment_requested → n8n. See _shared/wf-race.ts.

export function useRequestAppointment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: {
      withingsUserId: string | number;
      opts: RequestAppointmentOpts;
    }) => AppointmentService.requestAppointment(vars.withingsUserId, vars.opts),
    onSettled: () => scheduleInvalidate(qc, TASK_KEYS.all),
  });
}
